/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Client,
    ClientFromJSON,
    ClientFromJSONTyped,
    ClientToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReadOnlyMonitoringDevice
 */
export interface ReadOnlyMonitoringDevice {
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoringDevice
     */
    readonly id?: number;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoringDevice
     */
    clientId: number;
    /**
     * 
     * @type {Client}
     * @memberof ReadOnlyMonitoringDevice
     */
    client?: Client;
    /**
     * 
     * @type {object}
     * @memberof ReadOnlyMonitoringDevice
     */
    permissions?: object;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReadOnlyMonitoringDevice
     */
    readonly modules?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoringDevice
     */
    readonly deleted?: number;
    /**
     * 
     * @type {object}
     * @memberof ReadOnlyMonitoringDevice
     */
    metadata?: object | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoringDevice
     */
    serialNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoringDevice
     */
    externalVehicleId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReadOnlyMonitoringDevice
     */
    isEva?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoringDevice
     */
    monitoringDeviceType: number;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoringDevice
     */
    monitoringDeviceStatus?: number;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoringDevice
     */
    externalSystem?: number | null;
}

export function ReadOnlyMonitoringDeviceFromJSON(json: any): ReadOnlyMonitoringDevice {
    return ReadOnlyMonitoringDeviceFromJSONTyped(json, false);
}

export function ReadOnlyMonitoringDeviceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyMonitoringDevice {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'clientId': json['client_id'],
        'client': !exists(json, 'client') ? undefined : ClientFromJSON(json['client']),
        'permissions': !exists(json, 'permissions') ? undefined : json['permissions'],
        'modules': !exists(json, 'modules') ? undefined : json['modules'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'metadata': !exists(json, 'metadata') ? undefined : json['metadata'],
        'serialNumber': json['serial_number'],
        'externalVehicleId': !exists(json, 'external_vehicle_id') ? undefined : json['external_vehicle_id'],
        'isEva': !exists(json, 'is_eva') ? undefined : json['is_eva'],
        'monitoringDeviceType': json['monitoring_device_type'],
        'monitoringDeviceStatus': !exists(json, 'monitoring_device_status') ? undefined : json['monitoring_device_status'],
        'externalSystem': !exists(json, 'external_system') ? undefined : json['external_system'],
    };
}

export function ReadOnlyMonitoringDeviceToJSON(value?: ReadOnlyMonitoringDevice | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'client_id': value.clientId,
        'client': ClientToJSON(value.client),
        'permissions': value.permissions,
        'metadata': value.metadata,
        'serial_number': value.serialNumber,
        'external_vehicle_id': value.externalVehicleId,
        'is_eva': value.isEva,
        'monitoring_device_type': value.monitoringDeviceType,
        'monitoring_device_status': value.monitoringDeviceStatus,
        'external_system': value.externalSystem,
    };
}


